/* eslint-disable no-console */
import { ENVELOPES } from '../../../components/envelope-preview/constants';
import { useAppContext } from '../../../context/app-context';
import { useInitializationDataContext } from '../../../context/data-context';
import { EnvelopePreviewResponse } from '../../../global-types';
import { useIsDigitalGreeting } from '../../../hooks';
import { useIsOneToMany } from '../../../hooks/use-is-one-to-many';
import { getEnvelopePreview } from '../../../services';
import { getEnvelopePreviewBody } from '../utils';

export const useLoadPreviewOnFrontend = () => {
  const { initializedDataState } = useInitializationDataContext();
  const { isUS } = initializedDataState;
  const isDigitalGreetings = useIsDigitalGreeting();
  const {
    initializedDataState: { data: initializedData, addressData },
  } = useInitializationDataContext();
  const { appState } = useAppContext();
  const { previewImages } = appState;
  const isOneToMany = useIsOneToMany();
  const projectId = initializedData?.project_id || '';

  const getPreviews = async () => {
    if (isUS && !isDigitalGreetings) {
      const { recipient, sender } = addressData;
      if (!recipient && !sender) {
        // If no recipient/sender, add blank envelope to previewImages (1-to-many)
        previewImages.push({
          dataURL: ENVELOPES[0].image,
          type: 'Envelope',
        });
      } else if (initializedData && ((recipient && sender) || (isOneToMany && sender))) {
        // If we have recipient/sender, or if it's 1-to-many and we have sender, send request to get envelope preview
        const envelopePreviewIndex = previewImages.findIndex((preview) => preview.type === 'Envelope');
        if (envelopePreviewIndex > -1) {
          // If we already have an envelope preview, remove it
          previewImages.splice(envelopePreviewIndex, 1);
        }
        const envelopePreviewBody = getEnvelopePreviewBody(
          recipient,
          sender,
          initializedData.product.envelope_color,
          initializedData.variables.template_data.CardSize,
        );
        const envResponse: EnvelopePreviewResponse = await getEnvelopePreview(projectId, envelopePreviewBody);
        previewImages.push({
          dataURL: envResponse.data?.encoded_image as string,
          type: 'Envelope',
        });
      }
    }
    return previewImages;
  };

  return {
    getPreviews,
  };
};
